module.exports = __webpack_public_path__ + "static/img/teacher-download-bg.f5d8b2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/download/teacher-download-bg.png
// module id = CGt/
// module chunks = 2